import { IMacro, IMacroApiResponse } from "store/entities/macros/interfaces";

export const deserializeMacro = (macro: IMacroApiResponse): IMacro => ({
  id: macro.ID,
  licenseId: macro.licenseID,
  createdAt: macro.createdAt,
  createdBy: macro.createdBy,
  createdByType: macro.createdByType,
  updatedAt: macro.updatedAt,
  updatedBy: macro.updatedBy,
  agentId: macro.agentID,
  teamIds: macro.teamIDs,
  name: macro.name,
  description: macro.description,
  actions: macro.actions,
});

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deserializeMacros = (macros: any): IMacro[] => macros.map(deserializeMacro);
